import React from 'react';
import { getProcessSteps } from '../mockData';
import { Card, CardContent } from './ui/card';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Process = () => {
  const { language } = useLanguage();
  const processSteps = getProcessSteps(language);

  return (
    <section id="prozess" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fadeInUp">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {language === 'en' ? "It's this easy to your " : 'So einfach geht\'s zu Ihrer '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-600 to-amber-500">
              {language === 'en' ? 'Energy Transition' : 'Energiewende'}
            </span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {language === 'en' 
              ? 'In just 4 steps to your own energy independence'
              : 'In nur 4 Schritten zu Ihrer eigenen Energieunabhängigkeit'}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {processSteps.map((step, index) => (
            <div key={step.step} className="relative animate-fadeInUp" style={{ animationDelay: `${index * 0.2}s` }}>
              <Card className="h-full border-2 border-gray-100 hover:border-sky-200 transition-all duration-300 hover:shadow-lg hover-lift">
                <CardContent className="p-8">
                  <div className="relative">
                    <div className="w-16 h-16 bg-gradient-to-br from-sky-600 to-amber-500 rounded-2xl flex items-center justify-center mb-6 shadow-lg animate-scaleIn" style={{ animationDelay: `${index * 0.2 + 0.3}s` }}>
                      <span className="text-2xl font-bold text-white">{step.step}</span>
                    </div>
                    {index < processSteps.length - 1 && (
                      <div className="hidden lg:block absolute top-8 left-20 w-full">
                        <ArrowRight className="w-6 h-6 text-gray-300" />
                      </div>
                    )}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
